/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type MessageDelete_message$ref: FragmentReference;
declare export opaque type MessageDelete_message$fragmentType: MessageDelete_message$ref;
export type MessageDelete_message = {|
  +id: string,
  +$refType: MessageDelete_message$ref,
|};
export type MessageDelete_message$data = MessageDelete_message;
export type MessageDelete_message$key = {
  +$data?: MessageDelete_message$data,
  +$fragmentRefs: MessageDelete_message$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MessageDelete_message",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Message"
};
// prettier-ignore
(node/*: any*/).hash = 'eb9b217bd1bef67ed04a0522e30a0553';

module.exports = node;
